import type { PropsWithChildren } from 'react';
import React from 'react';
import { Button } from 'is24-corecss';
import { IconS24Downsize24 } from '@is24/cosma-ui-icons';
import { css } from '@emotion/css';
import { useIntl } from '@/i18n';

export type SolvencyPreviewProps = {
  onClose: () => void;
} & PropsWithChildren;

const styles = {
  stickyContent: css`
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  `,
  closePreviewButton: css`
    background-color: white !important;
    &:hover {
      background-color: #eaeaea !important;
    }
  `,
  scrollable: css`
    overflow-y: auto;
    overflow-x: hidden;
  `,
};

export const SolvencyPreview = ({ children, onClose }: SolvencyPreviewProps) => {
  const { t } = useIntl();

  return (
    <>
      <div className={`padding-top palm-padding-top-l padding-horizontal ${styles.scrollable}`}>
        <div className={`${styles.stickyContent} grid grid-flex grid-justify-end padding-top-l padding-right-l`}>
          <Button
            appearance={'ghost'}
            size={'small'}
            className={`grid-item ${styles.closePreviewButton}`}
            onClick={onClose}
          >
            <IconS24Downsize24
              style={{ top: '0.17em' }}
              className='font-heading-xsmall-regular button-icon-margin-right'
              inline
            />
            {t({ id: 'benefits.schufaCheckMieterPlus.solvencyChoice.button.closePreview' })}
          </Button>
        </div>
        {children}
      </div>
    </>
  );
};
